export default __webpack_public_path__ + "static/media/thumbnail.fbedc0ff.png";